export default class Plugin {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      translations: {
        de: {
          name: null,
          description: null
        },
        en: {
          name: null,
          description: null
        }
      },
      isFrontend: false,
      isBackend: false,
      hook: '',
      shortcut: '',
      scheduleAt: null,
      internalName: ''
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      translations: this.translations,
      isFrontend: this.isFrontend,
      isBackend: this.isBackend,
      hook: this.hook,
      shortcut: this.shortcut,
      scheduleAt: this.scheduleAt,
      internalName: this.internalName
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/plugin/model.js